import { number, object } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const SpendBonusSchema = object({
  accumulationThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
});
